import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { paths } from 'src/routes/paths';

import { roles } from 'src/utils/roles';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard, RoleBasedGuard, FeatureFlagGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const GlAdminListPage = lazy(() => import('src/pages/above-store/acct/gl/list'));
const AmountsSetupPage = lazy(() => import('src/pages/above-store/acct/amounts/setup'));
const AmountsEditorPage = lazy(() => import('src/pages/above-store/acct/amounts/editor'));

// ----------------------------------------------------------------------

// Mirrors IsAmountsEditorEnabled + IsAmountsEditorUser on the backend: the tenant must
// have oneview.config.amounts-editor-enabled, and the user ROLE_AMOUNTS_EDITOR or admin.
const amountsRoles = [roles.ADMIN, roles.AMOUNTS_EDITOR];

const amountsGuard = (page) => (
    <FeatureFlagGuard feature="amountsEditor">
        <RoleBasedGuard roles={amountsRoles}>{page}</RoleBasedGuard>
    </FeatureFlagGuard>
);

const layoutContent = (
    <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
            <Outlet />
        </Suspense>
    </DashboardLayout>
);

export const aboveStoreRoutes = [
    {
        path: paths.aboveStore.root,
        element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
        children: [
            {
                roles: [roles.ADMIN],
                path: 'acct/gl',
                children: [
                    { element: <RoleBasedGuard roles={[roles.ADMIN]} children={<GlAdminListPage />} />, index: true },
                    { path: 'list', element: <RoleBasedGuard roles={[roles.ADMIN]} children={<GlAdminListPage />} /> },
                ]
            },
            {
                roles: amountsRoles,
                path: 'acct/amounts',
                children: [
                    { path: 'setup', element: amountsGuard(<AmountsSetupPage />) },
                    { path: ':brand/editor', element: amountsGuard(<AmountsEditorPage />) },
                ]
            }
        ]
    }
];
